"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListOfStates = void 0;

var React = __importStar(require("react"));

var use_mounted_state_1 = require("./use-mounted-state");

var use_update_1 = require("./use-update");

var use_update_effect_1 = require("./use-update-effect");

function useListOfStates(stateSet, name) {
  if (stateSet === void 0) {
    stateSet = [];
  }

  if (name === void 0) {
    name = '';
  }

  var isMounted = use_mounted_state_1.useMountedState();
  var update = use_update_1.useUpdate();
  var index = React.useRef(0);
  use_update_effect_1.useUpdateEffect(function () {
    if (stateSet.length <= index.current) {
      index.current = stateSet.length - 1;
      update();
    }
  }, [stateSet.length]);
  var actions = React.useMemo(function () {
    return {
      setStateAt: function setStateAt(i) {
        if (isMounted() && stateSet.length > 0 && i !== index.current) {
          index.current = i >= 0 ? i % stateSet.length : stateSet.length + i % stateSet.length;
          update();
        }
      },
      setState: function setState(state) {
        if (isMounted()) {
          var i = stateSet.length ? stateSet.indexOf(state) : -1;

          if (i === -1) {
            throw new Error("State " + state + " in the list " + (name.length > 0 ? name : 'unknown') + " is not a valid state. It doesn't exist in the list!");
          }

          index.current = i;
          update();
        }
      },
      next: function next() {
        actions.setStateAt(index.current + 1);
      },
      prev: function prev() {
        actions.setStateAt(index.current - 1);
      }
    };
  }, [stateSet]);
  return __assign({
    state: stateSet[index.current],
    currentIndex: index.current
  }, actions);
}

exports.useListOfStates = useListOfStates;